import { render, staticRenderFns } from "./CourseLectureViewModal.vue?vue&type=template&id=54da2a76"
import script from "./CourseLectureViewModal.vue?vue&type=script&lang=js"
export * from "./CourseLectureViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports